
import { MarkerDetails } from '../models/GeoLocation';
import { toCapitalized } from '@fixit/utils';
import moment from 'moment';

export default {
	name: 'search-result-list-item-details',
	data: () => ({
		showMoreAvailableTime: false
	}),

	props: {
		category: Number,
		treatment: Number,
		datetime: String,
		item: Object,
		small: Boolean,
		xSmall: Boolean
	},
	computed: {
		availableSites() {
			return this.$store.getters['search/availableSites'](this.datetime && new Date(this.datetime), this.treatment);
		},

		isAvailable() {
			return this.availableSites.includes(this.item.siteId);
		},

		ratingPercentage() {
			return (Math.round(this.item.avarageRating * 2) / 2 / 5) * 100;
		}
	},
	filters: {
		capitalize: toCapitalized,
		// timeToNow: formatDateDayNameAndDate
	}
};
